module.exports = __webpack_public_path__ + "img/gioco.27ce9d0b.png";